import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import menu from '../menu/controlPlaneMenuConfig';
import '../menu/menu.css';

// Same visibility convention as the legacy menu. This grants no access.
function visible(item, user) {
  return !item.roles?.length || user?.globals?.includes('superadmin') ||
    item.roles.some(role => user?.roles?.includes(role));
}

export default function ControlPlaneSidebar({ isOpen, closeSidebar }) {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState({});
  if (!user) return null;
  const active = path => pathname === path || pathname.startsWith(`${path}/`);
  const link = (item, className) => <Link to={item.path} className={className}
    aria-current={active(item.path) ? 'page' : undefined}
    style={active(item.path) ? { color: '#15803d', fontWeight: 700, textDecoration: 'underline' } : undefined}
    onClick={() => { if (window.innerWidth <= 768) closeSidebar?.(); }}>{item.label}</Link>;

  return <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
    <nav aria-label="EveryID Ops">
      <ul aria-label="Ops areas">
        {menu.map(group => {
          if (group.path) return <li key={group.label}>{link(group, 'menu-group-link-single')}</li>;
          const children = group.children.filter(item => visible(item, user));
          const expanded = !collapsed[group.label];
          const id = `ops-menu-${group.label.toLowerCase()}`;
          return <li key={group.label}>
            <button type="button" className="menu-group-link-single" aria-expanded={expanded} aria-controls={id}
              style={{ background: 'transparent', border: 0, width: '100%', textAlign: 'left', cursor: 'pointer' }}
              onClick={() => setCollapsed(current => ({ ...current, [group.label]: expanded }))}>
              {group.label}<span aria-hidden="true"> {expanded ? '▾' : '▸'}</span>
            </button>
            <ul id={id} className="menu-sublist" hidden={!expanded}>
              {children.map(item => <li key={item.path}>{link(item)}</li>)}
              {!children.length && <li><span>No shortcuts available for your current role.</span></li>}
            </ul>
          </li>;
        })}
      </ul>
    </nav>
  </div>;
}
